/* eslint-disable no-undef */
import 'stylesOpenBankApp';
import 'commonsComponents/main.scss';

// @vendro
const React = require('react');
const { Provider } = require('react-redux');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @Stand Alone - requirements
const { requestProfileSuccess } = require('actions/profile');
const { requestTranslations } = require('actions/translations');
const getGlobalVariables = require('actions/globalVariables');
const { TRANSLATION_PLATFORM_PRI } = require('constants/translations');
const { getLanguage } = require('core/i18n').i18n;
const InvestmentFundView = require('ok-funds-card/containers/InvestmentFundView');
const InvestmentAlternativeFundView = require('ok-funds-card/containers/AlternativeFundView');
require('./app.scss');

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
        };
    }

    componentDidMount() {
        // Stand Alone - requirements
        this.props.requestProfileSuccess();
        this.props.requestTranslations(TRANSLATION_PLATFORM_PRI, getLanguage());
        this.props.getGlobalVariables();
    }

    componentDidUpdate() {
        const storeCopy = { ...this.props.store.getState() };
        if (
            !!storeCopy &&
            !!storeCopy.brokerInvestmentFunds.length &&
            !this.state.name
        ) {
            this.setState({ name: storeCopy.brokerInvestmentFunds[0].name });
            if (window.okFunds && window.okFunds.onChangeNameProduct)
                window.okFunds.onChangeNameProduct(
                    storeCopy.brokerInvestmentFunds[0].name,
                );
        }
    }

    render() {
        const isAlternativeFund =
            window.okFunds && window.okFunds.isAlternativeFund;

        const isinDefaultCode = isAlternativeFund
            ? 'LU1894681052'
            : 'LU0232524495';

        const fundIsin = !!this.props.isinCode
            ? this.props.isinCode
            : isinDefaultCode;

        const contextUriBrowser = window.okFunds
            ? window.okFunds.contextUriBrowser
            : null;

        if (
            this.props.translations.isFetchingPRI ||
            this.props.translations.errorPRI
        ) {
            return null;
        }

        return (
            <Provider store={this.props.store}>
                {isAlternativeFund ? (
                    <InvestmentAlternativeFundView
                        match={{
                            params: { idType: 'isin', id: fundIsin },
                        }}
                        isPublicUser
                        contextUriFundsLandingView={contextUriBrowser}
                    />
                ) : (
                    <InvestmentFundView
                        match={{
                            params: { idType: 'isin', id: fundIsin },
                        }}
                        isPublicUser
                        contextUriFundsLandingView={contextUriBrowser}
                    />
                )}
            </Provider>
        );
    }
}

App.propTypes = {
    getGlobalVariables: PropTypes.func.isRequired,
    requestTranslations: PropTypes.func.isRequired,
    requestProfileSuccess: PropTypes.func.isRequired,
    store: PropTypes.object.isRequired,
    isinCode: PropTypes.string,
    translations: PropTypes.object.isRequired,
    fundType: PropTypes.string,
};

const mapStateToProps = state => {
    return {
        translations: state.translations.toJS(),
    };
};

const mapDispatchToProps = dispatch => ({
    requestProfileSuccess: () => dispatch(requestProfileSuccess()),
    getGlobalVariables: () => dispatch(getGlobalVariables()),
    requestTranslations: (platform, lang) =>
        dispatch(requestTranslations(platform, lang)),
});

module.exports = connect(mapStateToProps, mapDispatchToProps)(App);
